const validatorAcceptInputFileMixin = {
  methods: {
    validatorAcceptInputFile(schema, itemValue) {
      if ('accept' in schema && itemValue) {
        let items = [];
        let acceptContains = false;

        if (Array.isArray(itemValue)) {
          items = itemValue
        } else {
          items.push(itemValue);
        }

        for (let item in items) {
          //se algum item do array nao for um arquivo retorna verdadeiro e nao continua a validação
          if(isFile(items[item]) === false && isFile(items[item].file) === false) return true;
          const acceptType = schema.accept.split(',');

          for (let itemType in acceptType) {
            const emptyChar = acceptType[itemType].replace(/[^a-zA-Z0-9]+/g, '');

            let validInput = false;
            if (emptyChar == 'image') 
            {
              validInput = items[item] ? items[item].type.includes(emptyChar) : items[item].field.type.includes(emptyChar);
            } 
            else {
              let extensions = items[item] ? items[item].name.split('.') : items[item].file.name.split('.');
              validInput = extensions[extensions.length - 1] == emptyChar;
            }

            if (validInput) {
              acceptContains = true;
            }
          }
          if (!acceptContains) {
            this.$store.dispatch('notification/showNotification', {
              color: 'error',
              text: 'Tipo do arquivo não é valido',
              showIconNotification: false
            });
          }
        }

        if (acceptContains) return true

        return false
      }

      return true;
    }
  }
};

const isFile = input => 'File' in window && input instanceof File;

export default validatorAcceptInputFileMixin;
